<template>
  <div class="sched-app-daily">
    <!-- Left side -->
    <div class="sched-app-daily-left" :class="channelColorCSS">
      <logo />
      <calendar />
      <channel-selector />
      <timezone-selector />
      <pref-icons />
    </div>

    <!-- Right side -->
    <div class="sched-app-daily-right">
      <program-filter />
      <daily-listing />
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import Calendar from '@/components/Calendar.vue'
import ProgramFilter from '@/components/ProgramFilter.vue'
import DailyListing from '@/components/DailyListing.vue'
import TimezoneSelector from '@/components/TimezoneSelector.vue'
import ChannelSelector from '@/components/ChannelSelector.vue'
import PrefIcons from '@/components/PrefIcons.vue'

export default {
  components: {
    Logo,
    Calendar,
    ProgramFilter,
    DailyListing,
    TimezoneSelector,
    ChannelSelector,
    PrefIcons
  },

  computed: {
    channelColorCSS () {
      return `sched-app-${this.$store.state.channel.value}-color`
    }
  }
}
</script>

<style>
.sched-app-daily {
  display: flex;
  height: 100%;
}

.sched-app-daily-left {
  flex: 0 0 340px;
  display: flex;
  flex-direction: column;

  align-items: center;
  border-right: solid 2px rgba(0, 0, 0, 0.1);
}

.sched-app-daily-right {
  flex: 1 1 auto;
}

</style>
